export default __webpack_public_path__ + "static/media/deposit.1161806d.svg";